import { render, staticRenderFns } from "./wallet-cash-withdrawal.vue?vue&type=template&id=0d067d32"
import script from "./wallet-cash-withdrawal.vue?vue&type=script&lang=js"
export * from "./wallet-cash-withdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports